// Allows to get an absolute image url from the Strapi API, because the local
// file provider in Strapi only returns the relative path.
export const postImgUrl = (url?: string) => {
  return process.env.NEXT_PUBLIC_STRAPI_ENV === "local"
    ? `${process.env.NEXT_PUBLIC_STRAPI_API_DOMAIN?.replace("/api", "")}${url}`
    : url;
};
